<template>
  <v-container class="allibo-joblist-container">
    <v-row class="allibo-job-wrapper">
      <v-col cols="12">
        <div
          class="ticket-form-container ats-form-container grey lighten-3 pa-3 rounded"
        >
          <v-form
            ref="formRef"
            v-model="valid"
            lazy-validation
            @submit.prevent.stop="handleSubmit"
          >
            <h2>
              {{ step === 1 ? "Invia il tuo CV" : "Completa i tuoi dati" }}
            </h2>

            <v-row v-if="step === 1">
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="candidate.firstName"
                  label="Nome"
                  :id="'id_' + Math.random()"
                  dense
                  background-color="white"
                  outlined
                  required
                  :rules="[requiredRules()]"
                  s
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="candidate.lastName"
                  label="Cognome"
                  :id="'id_' + Math.random()"
                  dense
                  background-color="white"
                  outlined
                  required
                  :rules="[requiredRules()]"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="candidate.email"
                  label="E-mail"
                  :id="'id_' + Math.random()"
                  dense
                  background-color="white"
                  outlined
                  required
                  :rules="isEmailRules"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <v-select
                  background-color="white"
                  v-model="selectedJobs"
                  :items="availableJobs"
                  label="Figura professionale"
                  multiple
                  item-value="value"
                  item-text="text"
                  :menu-props="{ maxHeight: '400px' }"
                  class="allibo-filter-job-provinces"
                  filled
                  hide-details
                >
                  <!-- Slot personalizzato per le opzioni con checkbox -->
                  <template v-slot:selection="{ item }">
                    <span> {{ item.title }}</span>
                  </template>

                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item
                      v-bind="attrs"
                      v-on="on"
                      :disabled="isItemDisabled(item)"
                    >
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="selectedJobs.includes(item)"
                          @change="
                            $event
                              ? selectedJobs.push(item)
                              : selectedJobs.splice(
                                  selectedJobs.indexOf(item),
                                  1
                                )
                          "
                          :disabled="isItemDisabled(item)"
                          :ripple="false"
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-file-input
                  outlined
                  background-color="white"
                  dense
                  v-model="attachmentModel"
                  accept="application/pdf,.doc,.docx"
                  label="File CV"
                  required
                  :rules="[requiredRules()]"
                ></v-file-input>
              </v-col>
              <!-- <v-col cols="12">
                <div class="d-flex align-center job-privacy">
                  <PrivacyLinks></PrivacyLinks>
                </div>
              </v-col> -->
              <v-col
                cols="12"
                @click="clicked"
                class="d-flex align-center my-4"
              >
                <v-checkbox v-model="supportData.privacy" />
                <span>Ho letto l'</span>
                <router-link
                  to="/page/privacy-policy"
                  :target="isCordova ? '_self' : '_blank'"
                  class="mx-1"
                >
                  <span>informativa Privacy </span>
                </router-link>
              </v-col>
            </v-row>

            <v-row v-if="step === 2">
              <v-col cols="12"><h3>Informazioni generali</h3></v-col>
              <v-col cols="12" md="3">
                <label v-html="`${$t('profile.contacts.mobilePhone')} *`" />
                <v-text-field
                  background-color="white"
                  :placeholder="`${$t('profile.contacts.mobilePhone')} *`"
                  v-model="candidate.phone"
                  required
                  :rules="mobilePhoneRules"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <!-- BIRTHDATE -->
              <v-col cols="12" md="3">
                <label v-html="`${$t('profile.birthDate')} *`" />
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      background-color="white"
                      v-model="candidate.birthday"
                      :placeholder="`${$t('profile.birthDate')} *`"
                      required
                      :rules="dateRules"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon slot="append">$editcalendar</v-icon>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    locale="it-IT"
                    ref="picker"
                    :active-picker.sync="activePicker"
                    v-model="candidate.birthday"
                    min="1910-01-01"
                    :max="$dayjs().format('YYYY-MM-DD')"
                    first-day-of-week="1"
                    type="date"
                    no-title
                    @input="onBirthdateInput"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col col="12" md="3">
                <label>Genere</label>
                <v-select
                  background-color="white"
                  placeholder="Genere"
                  v-model="supportData.gender"
                  :items="gender"
                  return-object
                  item-text="value"
                  item-value="value"
                  required
                  :rules="[requiredRules()]"
                  outlined
                  dense
                >
                </v-select>
              </v-col>
              <v-col col="12" md="3">
                <label>Appartenente alle categorie protette</label>
                <v-radio-group
                  class="mt-1"
                  dense
                  v-model="candidate.isProtectedCategory"
                  row
                >
                  <v-radio :value="true"
                    ><template v-slot:label>
                      <span> Sì</span>
                    </template></v-radio
                  >
                  <v-radio :value="false">
                    <template v-slot:label>
                      <span>No</span>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
              <!-- <v-col cols="12" md="3">
                <label>Foto</label>
                <v-file-input
                  outlined
                  background-color="white"
                  dense
                  v-model="supportData.customFields.additionalProp2"
                  accept=".jpg,.png,.svg"
                  label="Foto"
                  required
                ></v-file-input>
              </v-col> -->
            </v-row>
            <v-row v-if="step === 2">
              <v-col cols="12"><h3>Abitazione</h3></v-col>
              <!-- COUNTRY -->
              <v-col cols="12" md="3">
                <label v-html="`${$t('profile.address.country')}`" />
                <v-select
                  background-color="white"
                  :placeholder="`${$t('profile.address.country')}`"
                  v-model="supportData.country"
                  :items="customCountries"
                  return-object
                  item-text="name"
                  item-value="code"
                  required
                  outlined
                  dense
                  :rules="[requiredRules()]"
                />
              </v-col>
              <!-- PROVINCE -->
              <v-col cols="12" md="3">
                <label>Regione </label>
                <!-- <v-combobox
                  :placeholder="`${$t('profile.address.searchProvince')} *`"
                  v-model="candidate.region"
                  :items="provinceList"
                  append-icon=""
                  height="40"
                  outlined
                  dense
                  item-text="name"
                  item-value="name"
                ></v-combobox> -->
                <v-combobox
                  class="combobox"
                  background-color="white"
                  placeholder="Regione"
                  v-model="supportData.region"
                  :items="provinceList"
                  return-object
                  item-text="name"
                  item-value="name"
                  outlined
                  dense
                  :rules="[requiredRules()]"
                />
              </v-col>
              <!-- CITY (Italy) -->
              <v-col cols="12" md="3">
                <label>Località</label>
                <v-combobox
                  class="combobox"
                  background-color="white"
                  placeholder="Località"
                  v-model="supportData.city"
                  :items="citiesList"
                  return-object
                  item-text="name"
                  item-value="name"
                  required
                  outlined
                  dense
                  :rules="[requiredRules()]"
                />
              </v-col>
              <v-col col="12" md="3">
                <div><span>Disponibilità al trasferimento</span></div>

                <v-radio-group
                  dense
                  class="mt-1"
                  v-model="supportData.customFields.additionalProp1"
                  row
                  :rules="[requiredRules()]"
                >
                  <v-radio :value="true"
                    ><template v-slot:label>
                      <span> Sì</span>
                    </template></v-radio
                  >
                  <v-radio :value="false">
                    <template v-slot:label>
                      <span>No</span>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row v-if="step === 2">
              <v-col cols="12"><h3>Profilo professionale</h3></v-col>
              <v-col cols="12" md="4">
                <label>Esperienza lavorativa</label>
                <v-select
                  :rules="[requiredRules()]"
                  background-color="white"
                  placeholder="Eseperienze Lavorative"
                  v-model="supportData.workExperience"
                  :items="experiences"
                  return-object
                  item-text="jobTitle"
                  item-value="jobTitle"
                  required
                  outlined
                  dense/></v-col
              ><v-col cols="12" md="8">
                <label>Anni di esperienza</label>
                <div class="d-flex">
                  <!-- <v-text-field
                  background-color="white"
                  placeholder="Anni di esperienza"
                  v-model="candidate.studyLevelType"
                  required
                  outlined
                  dense
                ></v-text-field></v-col> -->
                  <v-col cols="12" md="4" class="pa-0">
                    <v-menu
                      ref="menu2"
                      v-model="menu2"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                      :disabled="
                        !supportData.workExperience.id ||
                          (supportData.workExperience &&
                            supportData.workExperience.id === 2)
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          background-color="white"
                          v-model="supportData.workExperience.startDate"
                          placeholder="Data di inizio"
                          readonly
                          outlined
                          dense
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon slot="append">$editcalendar</v-icon>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        locale="it-IT"
                        ref="picker"
                        :active-picker.sync="activePicker"
                        v-model="supportData.workExperience.startDate"
                        min="1910-01-01"
                        :max="$dayjs().format('YYYY-MM-DD')"
                        first-day-of-week="1"
                        type="date"
                        no-title
                        @input="onWorkStartDateInput"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="4" class="py-0">
                    <v-menu
                      ref="menu3"
                      v-model="menu3"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                      :disabled="
                        !supportData.workExperience.id ||
                          (supportData.workExperience &&
                            supportData.workExperience.id === 2)
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          background-color="white"
                          v-model="supportData.workExperience.endDate"
                          placeholder="Data di fine"
                          readonly
                          outlined
                          dense
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon slot="append">$editcalendar</v-icon>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        locale="it-IT"
                        ref="picker"
                        :active-picker.sync="activePicker"
                        v-model="supportData.workExperience.endDate"
                        min="1910-01-01"
                        :max="$dayjs().format('YYYY-MM-DD')"
                        first-day-of-week="1"
                        type="date"
                        no-title
                        @input="onWorkEndDateInput"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="step === 2">
              <v-col cols="12" md="4">
                <label>Istruzione</label>
                <v-select
                  background-color="white"
                  placeholder="Istruzione"
                  v-model="supportData.studyLevel"
                  :items="studies"
                  return-object
                  item-text="title"
                  item-value="title"
                  required
                  :rules="[requiredRules()]"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12" md="4">
                <label>Indirizzo di studi</label>
                <v-text-field
                  :disabled="!supportData.studyLevel"
                  background-color="white"
                  placeholder="Indirizzo studi"
                  v-model="candidate.studyField"
                  outlined
                  dense
                ></v-text-field
              ></v-col>
            </v-row>
            <!-- <v-row v-if="step === 2"
              ><v-col cols="12">
                <h3>Conoscenze linguistiche</h3>
                <v-col cols="12" md="4">
                  <v-select
                    placeholder="Italiano"
                    :items="studies"
                    return-object
                    item-text="title"
                    item-value="title"
                    required
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    placeholder="Inglese"
                    :items="studies"
                    return-object
                    item-text="title"
                    item-value="title"
                    required
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    placeholder="Tedesco"
                    :items="studies"
                    return-object
                    item-text="title"
                    item-value="title"
                    required
                    outlined
                    dense
                  />
                </v-col>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  placeholder="Francese"
                  :items="studies"
                  return-object
                  item-text="title"
                  item-value="title"
                  required
                  outlined
                  dense
                />
              </v-col>
            </v-row> -->
            <v-row v-if="step === 2">
              <v-col cols="12"><h3>Presentazione</h3></v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="recruiterNote.content"
                  outlined
                  background-color="white"
                  required
                  dense
                  label="Presentazione"
                >
                </v-textarea>
              </v-col>
            </v-row>
            <v-alert type="error" v-if="imgErrorString">{{
              $t("tickets.imgTooBigError")
            }}</v-alert>
            <div
              class="buttons-container mt-10 d-flex flex-column flex-sm-row justify-center"
            >
              <v-btn
                v-if="step === 2"
                depressed
                large
                color="primary"
                type="submit"
                min-width="250"
                :disabled="disableConfirm"
                >{{ $t("ticket.confirmBtn") }}</v-btn
              >
              <v-btn
                v-if="step === 1"
                depressed
                large
                color="primary"
                min-width="250"
                @click.prevent.stop="step = 2"
                :disabled="disableSubmit"
                >Continua</v-btn
              >
            </div>
          </v-form>
        </div>
      </v-col>
    </v-row>
  </v-container>
  <!-- <v-container v-else>Non ci sono jobs!</v-container> -->
</template>
<style scoped lang="scss">
::v-deep .allibo-filters .v-input__slot {
  background: rgba(49, 46, 129, 0.2) !important;
}
.allibo-filters {
  margin-bottom: 16px;
}
.allibo-job {
  display: block;
  padding: 16px;
  border: 1px $primary solid;
  border-radius: 16px;
  box-shadow: 0 0 4px 1px $primary;
  // margin-bottom: 16px;
  text-decoration: none;
  font-weight: bold;
}

.ats-form-container {
  ::v-deep .v-select .v-select__selection--comma {
    color: #000000de !important;
    font-weight: normal;
  }
  ::v-deep .v-select__slot {
    min-height: 40px;
    border-radius: 6px;
    color: #666;
  }
}

.combobox {
  ::v-deep .v-input__control {
    color: $primary;
    font-size: 16px;
  }

  ::v-deep ::placeholder {
    font-weight: normal !important;
  }

  ::v-deep input {
    // color: #003366; /* stesso blu del label */
    // font-weight: bold;
    // color: $primary;
    font-size: 16px;
    color: #000000de;
    font-weight: normal;
  }
}
</style>
<script>
import axios from "~/plugins/axios";
import clickHandler from "~/mixins/clickHandler";

// import TigrosService from "@/service/tigrosCustomService";

import {
  requiredValue,
  isCF,
  isEmail,
  isMobilePhone
} from "~/validator/validationRules";
// import PrivacyLinks from "@/components/navigation/PrivacyLinks.vue";

// import get from "lodash/get";
export default {
  data() {
    return {
      requiredRules: requiredValue,
      customCountries: [],
      citiesList: [],
      provinceList: [],
      recruiterNote: { content: "" },
      recruiterNotes: [],
      valid: false,
      menu: false,
      menu2: false,
      menu3: false,
      job: null,
      supportData: {
        workExperience: {},
        customFields: {
          additionalProp1: null,
          additionalProp2: null,
          additionalProp3: null
        }
      },
      candidate: {
        workExperiences: [],
        customFields: {
          additionalProp1: null,
          additionalProp2: null,
          additionalProp3: null
        }
      },
      attachmentModel: null,
      imgErrorString: false,
      availableJobs: [],
      selectedJobs: [],
      step: 1,
      countryId: null,
      activePicker: null,
      dateRules: [requiredValue("Digitare la data di nascita")],
      mobilePhoneRules: [
        requiredValue("Digitare il numero di cellulare"),
        isMobilePhone()
      ],
      isEmailRules: [requiredValue("Digitare l'email"), isEmail()],
      cfRules: [requiredValue(), isCF()],
      gender: [
        { value: "Maschio" },
        { value: "Femmina" },
        { value: "Altro/preferisco non rispondere" }
      ],
      experiences: [
        {
          id: 1,
          jobTitle: "Con esperienza",
          startDate: "",
          endDate: ""
        },
        { id: 2, jobTitle: "Senza esperienza", startDate: "", endDate: "" }
      ],
      studies: [
        { title: "Scuola dell'obbligo" },
        { title: "Scuola superiore" },
        { title: "Laurea breve (3 anni)" },
        { title: "Laurea magistrale" },
        { title: "Post-Laurea" }
      ]
    };
  },
  mixins: [clickHandler],
  computed: {
    // formattedDescription() {
    //   return this.job.description.replace(/\n/g, "<br>");
    // },
    disableSubmit() {
      return (
        this.step === 1 &&
        (!this.candidate.firstName ||
          !this.candidate.lastName ||
          !this.candidate.email ||
          !this.attachmentModel ||
          this.selectedJobs.length === 0 ||
          !this.supportData.privacy)
      );
    },
    disableConfirm() {
      console.log(this.candidate.phone);
      console.log(this.candidate.birthday);
      console.log(this.supportData.gender);
      console.log(this.supportData.customFields.additionalProp1);
      console.log(this.candidate.isProtectedCategory === undefined);
      console.log(this.supportData.country);
      console.log(this.supportData.city);
      console.log(this.supportData.region);
      console.log(this.supportData.workExperience.jobTitle);
      console.log(this.recruiterNote.content.length);

      return (
        this.step === 2 &&
        (!this.candidate.phone ||
          !this.candidate.birthday ||
          !this.supportData.gender ||
          this.supportData.customFields.additionalProp1 === undefined ||
          this.candidate.isProtectedCategory === undefined ||
          !this.supportData.country ||
          !this.supportData.city ||
          !this.supportData.region ||
          // this.candidate.customFields.additionalProp2 === undefined)) ||
          !this.supportData.workExperience.jobTitle ||
          this.recruiterNote.content.length === 0)
      );
    }
  },
  methods: {
    onBirthdateInput() {
      this.menu = false;
    },
    onWorkStartDateInput() {
      this.menu2 = false;
    },
    onWorkEndDateInput() {
      this.menu3 = false;
    },
    isItemDisabled(item) {
      return this.selectedJobs.length > 0 && !this.selectedJobs.includes(item);
    },
    async toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    async handleSubmit(e) {
      var _this = this;
      console.log(_this);
      e.preventDefault();

      //file deve essere minore di 2mb
      if (_this.attachmentModel && _this.attachmentModel.size / 1024 > 5120) {
        _this.imgErrorString = true;
      } else {
        _this.imgErrorString = false;

        if (_this.attachmentModel) {
          _this.attachmentModel.cvBase64 = await _this.toBase64(
            _this.attachmentModel
          );
        }
      }

      // if (
      //   _this.candidate.customFields.additionalProp2 &&
      //   this.candidate.customFields.additionalProp2.size / 1024 > 5120
      // ) {
      //   _this.imgErrorString = true;
      // } else {
      //   _this.imgErrorString = false;

      //   if (_this.candidate.customFields.additionalProp2) {
      //     _this.candidate.customFields.additionalProp2.cvBase64 = await _this.toBase64(
      //       _this.candidate.customFields.additionalProp2
      //     );
      //   }
      // }

      if (_this.recruiterNote.content.length > 0) {
        _this.recruiterNotes.push(_this.recruiterNote);
      }

      if (this.selectedJobs.length > 0) {
        this.job = this.selectedJobs[0];
      }
      let url =
        "https://europe-west1-steps-c4a79.cloudfunctions.net/api/applies";

      this.candidate.country = this.supportData.country
        ? this.supportData.country.code
        : "";
      this.candidate.region = this.supportData.region
        ? this.supportData.region.name
        : "";
      this.candidate.city = this.supportData.city
        ? this.supportData.city.name
        : "";
      this.candidate.gender = this.supportData.gender
        ? this.supportData.gender.value
        : "";
      this.candidate.studyLevel = this.supportData.studyLevel.title
        ? this.supportData.studyLevel.title
        : "";
      this.candidate.birthday = this.$dayjs(this.candidate.birthday).format(
        "DD/MM/YYYY"
      );
      this.candidate.birthday = this.$dayjs(this.candidate.birthday).format(
        "DD/MM/YYYY"
      );

      this.supportData.workExperience.endDate = this.$dayjs(
        this.supportData.workExperience.endDate
      ).format("DD/MM/YYYY");

      this.candidate.workExperiences.push(this.supportData.workExperience);

      const requestBody = {
        candidate: this.candidate,
        jobPostId: this.job.id,
        cvBase64: this.attachmentModel.cvBase64,
        cvFilename: this.attachmentModel.name,
        recruiterNotes: this.recruiterNotes
      };

      return axios
        .post(url, requestBody, {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.VUE_APP_STEPSCONNECT_KEY
          }
        })
        .then(response => {
          if (response.status === 200 || response.status === 201) {
            //             global.EventBus.$emit("success", {
            //   message: global.EventBus.$t("workWithUs.formSubmitted")
            // });
            _this.$refs.formRef.reset(); // reset form
            _this.$router.push({ name: "JobThankYouPage" });
          }
        })
        .catch(error => {
          console.error("Errore nell'invio della candidatura:", error);
          global.EventBus.$emit("error", {
            message: global.EventBus.$t("workWithUs.formSubmittedError")
          });
        });
    },
    async fetchJob() {
      let url = `https://europe-west1-steps-c4a79.cloudfunctions.net/api/job-posts`;
      return axios
        .get(url, {
          headers: {
            accept: "application/json",
            "x-api-key": process.env.VUE_APP_STEPSCONNECT_KEY
          }
        })
        .then(response => {
          let result = response.data.filter(res => {
            return res.status === "published";
          });
          return result;
        })
        .catch(error => {
          console.log(error);
        });
    },
    shareOnWA() {
      //let share = this.createStringList(true);
      // let share = encodeURIComponent(this.createStringList(true).join("\n\n"));
      let share = encodeURIComponent(this.createStringList(true).join("\r\n"));
      // window.location.href = `https://api.whatsapp.com/send?text=${share}`;
      if (this.$platform_is_cordova) {
        window.cordova.InAppBrowser.open(
          "https://api.whatsapp.com/send/?phone&text=" + share,
          "_system"
        );
      } else {
        if (
          /android|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          window.open(
            "https://api.whatsapp.com/send/?phone&text=" + share,
            "_blank"
          );
        } else {
          window.open(
            "https://web.whatsapp.com/send/?phone&text=" + share,
            "_blank"
          );
        }
      }
    },
    shareOnEmail() {
      let share = encodeURIComponent(this.createStringList().join("\n\n"));
      window.location = `mailto:?subject=GUARDA QUESTO ANNUNCIO DI LAVORO: ${this.JOB.title} &body=${share}`;
    },
    async getCountries() {
      let url = `https://europe-west1-steps-c4a79.cloudfunctions.net/api/countries?limit=250`;

      return axios
        .get(url, {
          headers: {
            accept: "application/json",
            "x-api-key": process.env.VUE_APP_STEPSCONNECT_KEY
          }
        })
        .then(response => {
          return response.data.docs;
        });
    },
    async getProvinces(countryId) {
      let url = `https://europe-west1-steps-c4a79.cloudfunctions.net/api/regions?country_id=${countryId}&limit=250`;

      return axios
        .get(url, {
          headers: {
            accept: "application/json",
            "x-api-key": process.env.VUE_APP_STEPSCONNECT_KEY
          }
        })
        .then(response => {
          let result = response.data.docs.filter(res => {
            return res.country_id === countryId;
          });
          if (result.length == 0) {
            return null;
          }
          return result;
        });
    },
    async getCities(regionId) {
      let _this = this;
      let url = `https://europe-west1-steps-c4a79.cloudfunctions.net/api/cities?country_id=${this.countryId}&region_id=${regionId}&limit=150435`;

      return axios
        .get(url, {
          headers: {
            accept: "application/json",
            "x-api-key": process.env.VUE_APP_STEPSCONNECT_KEY
          }
        })
        .then(response => {
          let result = response.data.docs.filter(res => {
            return (
              res.country_id === _this.countryId && res.region_id === regionId
            );
          });
          if (result.length == 0) {
            return null;
          }
          return result;
        });
    }
  },
  async created() {
    this.availableJobs = await this.fetchJob();
  },
  async mounted() {
    // await this.getProvinces(this.customCountries[0], false);
    // GET COUNTRIES FROM STEPSCONNECT
    this.customCountries = await this.getCountries();
  },
  watch: {
    async "supportData.country"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.provinceList = await this.getProvinces(newVal.id);
        this.countryId = newVal.id;
      }
    },
    async "supportData.region"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.citiesList = await this.getCities(newVal.id);
      }
    }
  }
};
</script>
